var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.006,
    height: 64.873,
    viewBox: "0 0 70.006 64.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#292929;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-674.994 -2246)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.955,69.435H19.045a1,1,0,0,1-.529-.152,35,35,0,1,1,36.968,0A1,1,0,0,1,54.955,69.435Zm-35.622-2H54.667a33,33,0,1,0-35.334,0Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.607,58.871a1,1,0,0,1-.84-1.541,33.129,33.129,0,0,0,3.654-7.713,1,1,0,1,1,1.9.615,35.092,35.092,0,0,1-3.873,8.179A1,1,0,0,1,65.607,58.871Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M60.254,50.31a1,1,0,0,1-.921-1.392,23.807,23.807,0,0,0,1.924-9.353,24.257,24.257,0,0,0-48.514,0,23.807,23.807,0,0,0,1.924,9.353,1,1,0,1,1-1.842.783,25.8,25.8,0,0,1-2.082-10.136,26.257,26.257,0,1,1,52.514,0A25.8,25.8,0,0,1,61.175,49.7a1,1,0,0,1-.921.61Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.249,55.847a6.683,6.683,0,1,1,6.683-6.683,6.683,6.683,0,0,1-6.683,6.683Zm0-11.366a4.684,4.684,0,1,0,2.04.468,4.684,4.684,0,0,0-2.04-.468Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.178,47.6a.931.931,0,0,1-.166-.015,1,1,0,0,1-.824-.847L28.269,25.861a1,1,0,0,1,1.858-.635L40.594,43.553a1,1,0,0,1-1.309,1.394,4.682,4.682,0,0,0-6.217,2.108,1,1,0,0,1-.89.545ZM30.969,30.733,32.844,44.14a6.721,6.721,0,0,1,4.843-1.64Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37,8.963a1,1,0,0,1-1-1v-2.4a1,1,0,0,1,2,0v2.4A1,1,0,0,1,37,8.963Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.233,13.322a1,1,0,0,1-.867-.5l-1.2-2.077a1,1,0,1,1,1.732-1l1.2,2.077a1,1,0,0,1-.866,1.5Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.755,24.98a.992.992,0,0,1-.5-.134l-2.076-1.2a1,1,0,1,1,1-1.731l2.076,1.2a1,1,0,0,1-.5,1.866Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.646,40.814h-2.4a1,1,0,0,1,0-2h2.4a1,1,0,0,1,0,2Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.93,57.781a1,1,0,0,1-.5-1.866l2.076-1.2a1,1,0,1,1,1,1.731l-2.076,1.2a.986.986,0,0,1-.5.135Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.767,13.322a1,1,0,0,1-.866-1.5l1.2-2.077a1,1,0,1,1,1.732,1l-1.2,2.077a1,1,0,0,1-.866.5Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M64.245,24.98a1,1,0,0,1-.5-1.866l2.076-1.2a1,1,0,1,1,1,1.731l-2.076,1.2a.992.992,0,0,1-.5.135Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M70.751,40.814h-2.4a1,1,0,0,1,0-2h2.4a1,1,0,0,1,0,2Z",
    transform: "translate(672.997 2241.438)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M66.07,57.781a.986.986,0,0,1-.5-.135l-2.076-1.2a1,1,0,1,1,1-1.731l2.076,1.2a1,1,0,0,1-.5,1.866Z",
    transform: "translate(672.997 2241.438)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.8f5ba948c2220ce06b9fccff5202e39e.svg";
export { ForwardRef as ReactComponent };